// This is a validation/path-safety allowlist, not a rendering capability list.
// Runtime availability comes exclusively from auth-service.
export const KNOWN_ACCOUNT_DELETION_SSO_PROVIDERS = Object.freeze(["google", "apple"]);

const KNOWN_PROVIDER_SET = new Set(KNOWN_ACCOUNT_DELETION_SSO_PROVIDERS);

export const isKnownAccountDeletionSsoProvider = (provider) => (
    KNOWN_PROVIDER_SET.has(provider)
);

export const parseAccountDeletionSsoCapabilities = (value) => {
    const keys = value && typeof value === "object" && !Array.isArray(value)
        ? Reflect.ownKeys(value)
        : [];
    if (!value || typeof value !== "object" || Array.isArray(value)
        || Object.getPrototypeOf(value) !== Object.prototype
        || keys.length !== 1 || keys[0] !== "providers"
        || !Object.prototype.hasOwnProperty.call(value, "providers")
        || !Array.isArray(value.providers)) {
        throw new TypeError("Account-deletion SSO capabilities are malformed");
    }
    const seen = new Set();
    const providers = value.providers.map((provider) => {
        if (typeof provider !== "string"
            || !isKnownAccountDeletionSsoProvider(provider)
            || seen.has(provider)) {
            throw new TypeError("Account-deletion SSO capabilities are malformed");
        }
        seen.add(provider);
        return provider;
    });
    return Object.freeze(providers);
};
